import { z } from 'zod';

export const visitPlanSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  name: z.string(),
  code: z.string(),
  remarks: z.string().optional(),
  effectiveWeek: z.number(),
  weekStep: z.number(),
});

export const getVisitPlansSchema = z.array(visitPlanSchema);

export type GetVisitPlansResponse = z.infer<typeof getVisitPlansSchema>;
